module.exports = __webpack_public_path__ + "static/img/icon_shaixuan2@2x.38b2a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trademark/brand/icon_shaixuan2@2x.png
// module id = kMx4
// module chunks = 0